import { render, staticRenderFns } from "./socialMediaIcons.vue?vue&type=template&id=6c5fffec&scoped=true"
import script from "./socialMediaIcons.vue?vue&type=script&lang=js"
export * from "./socialMediaIcons.vue?vue&type=script&lang=js"
import style0 from "./socialMediaIcons.vue?vue&type=style&index=0&id=6c5fffec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5fffec",
  null
  
)

export default component.exports